import { GridTableRecord } from "@apex/component-library";
import Papa from "papaparse";

import { marginProcessingExportFileName } from "../components/CallAlertsAuxWindow/auxUtils";

// make a JSDoc for the following component
/**
 * Export the data to a CSV and download it
 * @param data - GridTableRecord array
 * this function is used to export the data to a CSV and download it
 * @returns void
 * it will name the file as `AFS-MarginProcessing-Export_${DateTime.now().toFormat("yyyyMMdd")}`
 */
export const csvExportAndDownload = (data: GridTableRecord[]) => {
  const csv = Papa.unparse(data, {
    quotes: true,
  });

  const fileName = marginProcessingExportFileName();
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
